/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, ComposedChart, Line,
  Label, LabelList
} from 'recharts';
import { colorsCombination, setCurrencyFormat } from '../../../../utils/helpers';

const ViewsVsSalesChart = ({
  dir, dataToPlot, height,
  index
}) => {

  const [color1, color2, color3] = colorsCombination[(index) % 10];
  
  const kFormatter = (num) => {
    const value = Math.abs(num) > 999
     ? `${Math.sign(num) * (Math.abs(num) / 1000).toFixed(1)}k` 
     : Math.sign(num) * Math.abs(num);
     return value;
};

  return (
    <Col xs={12} style={{marginTop: '10px'}}>
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <ComposedChart
            data={dataToPlot}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid vertical={false} horizontal stroke="#FF0000" strokeWidth={2} />
            <XAxis dataKey="reportDate" reversed={dir === 'rtl'} />
            <YAxis type="number" />
            <YAxis yAxisId="left" orientation={dir === 'rtl' ? 'right' : 'left'}
             // tickFormatter={item => setCurrencyFormat(item, false)}
             tickFormatter={kFormatter}
              width={90} type="number"
              allowDataOverflow >
              <Label angle={-90} value="Ordered Product Sales"
                position='insideLeft' style={{ textAnchor: 'middle' }} />
            </YAxis>
            <YAxis yAxisId="right" orientation={dir === 'rtl' ? 'left' : 'right'}
              // tickFormatter={item => setCurrencyFormat(item, false)}
              tickFormatter={kFormatter}
              width={90} type="number"
              allowDataOverflow >
              <Label angle={-90} value="Page View And Sessions"
                position='insideRight' style={{ textAnchor: 'middle' }} />
            </YAxis>
            <Tooltip />  <Legend />
            <Bar yAxisId="left"  dataKey={"amount"?.toString()} fill='#71f598'
            formatter={item => setCurrencyFormat(Number(item).toFixed(2), true)} />
            <Line yAxisId="right" type="monotone" dot={{fill: 'red'}} dataKey={"page view"?.toString()} stroke='#FF0000'>
              <LabelList dataKey={"page view"?.toString()} formatter={value => setCurrencyFormat(value, false)}
              position="top" style={{fontSize: '8px', fontWeight: 'bold'}}  />
            </Line>
            <Line yAxisId="right" type="monotone" dot={false}  dataKey={"sessions"?.toString()} stroke='#807878' />
            
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Col>
  );
};

ViewsVsSalesChart.propTypes = {
  dir: PropTypes.string.isRequired,
  dataToPlot: PropTypes.arrayOf({}).isRequired,
  height: PropTypes.number.isRequired,
  index: PropTypes.number,
};

ViewsVsSalesChart.defaultProps = {
  index: 0
}

export default ViewsVsSalesChart;
